class CookieBanner extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };
    this.banner = this.querySelector('.cookie-banner');
    this._retryCount = 0;

    if (this.dataset.testMode === 'true') {
      this.init();
      this.querySelectorAll('.button').forEach((button) => button.addEventListener('click', this.close.bind(this)));
    } else {
      this.loadConsentApi(() => this.beforeInitSafe());
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }

  onSectionSelect(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }

  onSectionDeselect(event) {
    filterShopifyEvent(event, this, () => this.close.bind(this));
  }

  loadConsentApi(callback) {
    const run = () => {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        this._retryCount += 1;
        if (this._retryCount > 20) return;
        setTimeout(run, 50);
        return;
      }

      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) return;
        if (typeof callback === 'function') callback();
      });
    };

    run();
  }

  getCustomerPrivacy() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return null;
    if (typeof cp.userCanBeTracked !== 'function') return null;
    if (typeof cp.getTrackingConsent !== 'function') return null;
    return cp;
  }

  beforeInitSafe() {
    try {
      const cp = this.getCustomerPrivacy();
      if (!cp) {
        this._retryCount += 1;
        if (this._retryCount > 20) return;
        setTimeout(() => this.beforeInitSafe(), 50);
        return;
      }

      const userCanBeTracked = cp.userCanBeTracked();
      const userTrackingConsent = cp.getTrackingConsent();

      if (!window.location.pathname.match(/^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart$/) && !userCanBeTracked && userTrackingConsent === 'no_interaction') {
        this.init();
      }
    } catch (e) {}
  }

  init() {
    const delay = parseInt(this.dataset.delay, 10);
    const isBrowserRendered = window.performance && window.performance.navigation && window.performance.navigation.type === 2;

    if (!this.banner || isBrowserRendered) return;

    if (delay > 0) {
      setTimeout(() => this.open(), delay * 1000);
    } else {
      this.open();
    }

    this.querySelectorAll('.button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  open() {
    if (this.banner) this.banner.classList.add(this.classes.activeClass);
    this.classList.remove('hidden');
  }

  close() {
    if (!this.banner) return;
    this.banner.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.banner.classList.remove(this.classes.closingClass);
      this.banner.classList.remove(this.classes.activeClass);
      this.classList.add('hidden');
    }, 500);
  }

  noop() {}

  onButtonClick(event) {
    this.close();

    const cp = this.getCustomerPrivacy();
    if (!cp || typeof cp.setTrackingConsent !== 'function') return;

    if (event.target.name === 'accept') {
      try {
        cp.setTrackingConsent(true, this.noop);
      } catch (e) {}

      document.addEventListener('trackingConsentAccepted', () => {});
    } else {
      try {
        cp.setTrackingConsent(false, this.noop);
      } catch (e) {}
    }
  }
}

customElements.define('cookie-banner', CookieBanner);
